/* ==========================================================================
   Apple Lux pages — family-page interactions.
   Loaded by apple-lux-lineup.liquid. Kept separate from apple.js (PDP-owned)
   so pushes from either branch never clobber the other's script.
   ========================================================================== */
(function () {
  'use strict';

  /* Flagship card video: autoplay the Signature intro once when it scrolls into
     view, then reveal a replay control on hover — mirrors the PDP hero, but
     self-contained (no intro-curtain gating, no [data-ap-hero-play] section). */
  (function cardVideo() {
    var wells = document.querySelectorAll('[data-apx-video]');
    if (!wells.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    Array.prototype.forEach.call(wells, function (well) {
      var video = well.querySelector('video');
      if (!video) return;
      var replay = well.querySelector('[data-apx-video-replay]');

      video.addEventListener('ended', function () { well.classList.add('is-done'); });

      if (reduce) {
        /* rest on the final beauty frame, no motion */
        var seekEnd = function () { try { video.currentTime = Math.max(0, video.duration - 0.05); } catch (e) {} };
        if (video.readyState >= 1) { seekEnd(); } else { video.addEventListener('loadedmetadata', seekEnd); }
        return;
      }

      var played = false;
      function start() {
        if (played || document.hidden) return;
        played = true;
        if (replay) replay.removeAttribute('hidden');
        video.play().catch(function () { well.classList.add('is-done'); });
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { start(); io.disconnect(); }
          });
        }, { threshold: 0.4 });
        io.observe(well);
      } else {
        start();
      }

      if (replay) {
        replay.addEventListener('click', function () {
          well.classList.remove('is-done');
          video.currentTime = 0;
          video.play().catch(function () {});
          replay.blur();
        });
      }
    });
  })();

  /* Feature gallery: slide 0 = the hero video, then stills; arrows/dots cycle.
     Replay control only applies on the video slide. */
  (function featureGallery() {
    var media = document.querySelector('[data-apx-fgal]');
    if (!media) return;
    var video = media.querySelector('.apx-feature__video');
    var imgs = media.querySelectorAll('.apx-feature__slide');
    if (!imgs.length) return;
    var dots = media.querySelectorAll('[data-apx-gal-dot]');
    /* with a hero clip, slide 0 is the video; without one the stills stand alone */
    var hasVideo = !!video;
    var total = imgs.length + (hasVideo ? 1 : 0);
    if (total < 2) return;
    var idx = 0;
    function show(i) {
      idx = (i + total) % total;
      media.classList.toggle('is-imgmode', hasVideo ? idx !== 0 : true);
      var active = hasVideo ? idx - 1 : idx;
      imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === active); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
      if (video && idx !== 0) { try { video.pause(); } catch (e) {} }
    }
    var touched = false; /* manual nav wins over the hover swap, same as the cards */
    var prev = media.querySelector('[data-apx-gal-prev]');
    var next = media.querySelector('[data-apx-gal-next]');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); touched = true; show(idx - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); touched = true; show(idx + 1); });
    dots.forEach(function (d, n) { d.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); touched = true; show(n); }); });

    /* hovering anywhere in the feature swaps to the first still and back, exactly
       like the Onyx / Luca cards */
    var feature = media.closest('.apx-feature') || media;
    feature.addEventListener('mouseenter', function () {
      touched = false;
      if (idx === 0) show(1);
    });
    feature.addEventListener('mouseleave', function () {
      if (!touched) show(0);
    });
  })();

  /* Card mini-gallery: slide 0 = iso render. Hovering the card advances to the
     lifestyle slide; arrows/dots cycle all slides; leaving rests back on iso. */
  (function cardGallery() {
    var gals = document.querySelectorAll('[data-apx-gal]');
    if (!gals.length) return;
    gals.forEach(function (gal) {
      var slides = gal.querySelectorAll('.apx-card__slide');
      if (slides.length < 2) return;
      var dots = gal.querySelectorAll('[data-apx-gal-dot]');
      var card = gal.closest('.apx-card') || gal;
      var idx = 0;
      var touched = false; /* manual nav wins over the hover auto-swap */
      function show(i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
      }
      function nav(delta) {
        return function (e) {
          e.preventDefault();
          e.stopPropagation();
          touched = true;
          show(idx + delta);
        };
      }
      var prev = gal.querySelector('[data-apx-gal-prev]');
      var next = gal.querySelector('[data-apx-gal-next]');
      if (prev) prev.addEventListener('click', nav(-1));
      if (next) next.addEventListener('click', nav(1));
      dots.forEach(function (d, n) {
        d.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          touched = true;
          show(n);
        });
      });
      card.addEventListener('mouseenter', function () {
        touched = false;
        if (idx === 0) show(1);
      });
      card.addEventListener('mouseleave', function () {
        if (!touched) show(0);
      });
    });
  })();

  /* Scroll cue: bounce three times whenever it comes into view, smooth-scroll on click. */
  (function scrollCue() {
    var cue = document.querySelector('[data-apx-cue]');
    if (!cue) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            cue.classList.remove('is-in');
            void cue.offsetWidth; /* restart the 3-bounce run */
            cue.classList.add('is-in');
          } else {
            cue.classList.remove('is-in');
          }
        });
      }, { threshold: 0.6 });
      io.observe(cue);
    } else {
      cue.classList.add('is-in');
    }
    cue.addEventListener('click', function (e) {
      var id = cue.getAttribute('href');
      if (!id || id.charAt(0) !== '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  })();

  /* Compare column peek: hover a model header -> column tints, tile lifts, and a
     floating card fades in with an auto-cycling collage + differentiator points. */
  (function cmpPeek() {
    if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var ths = document.querySelectorAll('.apx-cmp__prod');
    if (!ths.length) return;
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var allNameTops = []; /* uniform collage height: every column uses the shared minimum */
    ths.forEach(function (th, i) {
      var peek = th.querySelector('[data-apx-peek]');
      if (!peek) return;
      var imgs = th.querySelectorAll('.apx-peek__img');
      var descEl = th.querySelector('.apx-cmp__desc');
      var tileEl = th.querySelector('.apx-cmp__tile');
      var nameEl = th.querySelector('.apx-cmp__name');
      /* measured once at load — measuring on hover races the padding/collapse
         transitions and yields inflated offsets (title ends up under the collage) */
      var nameTop0 = nameEl ? nameEl.offsetTop : 220;
      allNameTops.push(nameTop0);
      var mediaImgs = [];
      var table = th.closest('table');
      var timer = null;
      var idx = 0;
      function colCells() {
        return table.querySelectorAll('tbody tr > *:nth-child(' + (i + 2) + ')');
      }
      function setImg(n) {
        idx = n;
        mediaImgs.forEach(function (im, k) { im.classList.toggle('is-active', k === idx); });
      }
      var closeT = null;
      function openPeek() {
        clearTimeout(closeT);
        if (th.classList.contains('is-peek')) return;
        th.classList.add('is-peek');
        peek.classList.add('is-open');
        var wrapEl = table.parentElement;
        var g = wrapEl.querySelector('.apx-cmp__colghost');
        /* column switch: never move a live card sideways — fade the old one out
           where it is and let a fresh one fade in at this column */
        if (g && g._owner !== th && g.classList.contains('is-on')) {
          var oldG = g;
          oldG.classList.remove('is-on');
          setTimeout(function () { if (oldG.parentNode) oldG.parentNode.removeChild(oldG); }, 650);
          g = null;
        }
        if (!g) { g = document.createElement('div'); g.className = 'apx-cmp__colghost'; wrapEl.insertBefore(g, wrapEl.firstChild); }
        var pad = 18; /* breathing room around the lifted column */
        /* the panel opens right under this column's OWN price/CTA — anchoring at
           the shared row bottom leaves the tallest column's dead space as a void,
           and the CTA must not move while the user is heading for it */
        var ctaEl = th.querySelector('.apx-cmp__cta');
        var anchorEl = ctaEl || descEl;
        var contentBottom = anchorEl ? (anchorEl.offsetTop + anchorEl.offsetHeight) : nameTop0;
        peek.style.top = (contentBottom + 16) + 'px';
        /* cells only slide as far as the panel actually overflows the header;
           TRANSFORM (not layout), so the shared rows never resize and the other
           columns never move — the card overflows the table bottom instead */
        var shift = Math.max(0, contentBottom + 16 + peek.offsetHeight + 24 - th.offsetHeight);
        function syncGhost() {
          var wr = wrapEl.getBoundingClientRect(), tr = th.getBoundingClientRect(), tb = table.getBoundingClientRect();
          g.style.left = (tr.left - wr.left + wrapEl.scrollLeft) + 'px';
          g.style.width = tr.width + 'px';
          g.style.top = (tb.top - wr.top - pad) + 'px';
          g.style.height = (tb.height + shift + pad * 2) + 'px';
        }
        syncGhost();
        if (th._ghostSyncs) th._ghostSyncs.forEach(clearTimeout);
        th._ghostSyncs = [setTimeout(syncGhost, 320), setTimeout(syncGhost, 700)];
        colCells().forEach(function (c) { c.style.transform = 'translateY(' + shift + 'px)'; });
        /* 09-30 (Ian): the card overflows the table bottom by `shift` — pad the
           wrapper by the same amount so the section below (From the Designer)
           moves down with it instead of being overlapped. Owner-tracked so a
           column switch's delayed close can't wipe the new column's padding. */
        wrapEl.style.paddingBottom = (shift ? shift + pad : 0) + 'px';
        wrapEl._padOwner = th;
        /* full-bleed collage: clone the column's images into the ghost's media zone,
           sized from the ghost top down to just above the product name */
        var media = g.querySelector('.apx-cmp__ghostmedia');
        if (!media) { media = document.createElement('div'); media.className = 'apx-cmp__ghostmedia'; g.appendChild(media); }
        /* crossfade on column switch: the previous column's slides fade out and
           are only removed after the fade — wiping them here flashes them away.
           Freeze the Ken Burns transform first, else dropping is-active snaps
           the zoom back mid-fade. */
        Array.prototype.slice.call(media.children).forEach(function (old) {
          old.style.transform = getComputedStyle(old).transform;
          old.classList.remove('is-active');
          setTimeout(function () { if (old.parentNode) old.parentNode.removeChild(old); }, 500);
        });
        mediaImgs = [];
        imgs.forEach(function (im) {
          var cl = document.createElement('img');
          cl.src = im.src; cl.alt = '';
          cl.className = 'apx-cmp__ghostimg';
          media.appendChild(cl); mediaImgs.push(cl);
        });
        idx = 0;
        /* style flush so the first slide FADES in instead of popping */
        void media.offsetWidth;
        if (mediaImgs[0]) mediaImgs[0].classList.add('is-active');
        media.style.height = (pad + Math.min.apply(null, allNameTops) - 24) + 'px';
        g.classList.add('is-on');
        g._owner = th;
        if (imgs.length > 1 && !reduce) {
          timer = setInterval(function () { setImg((idx + 1) % imgs.length); }, 1700);
        }
      }
      function closePeek() {
        th.classList.remove('is-peek');
        peek.classList.remove('is-open');
        var g0 = table.parentElement.querySelector('.apx-cmp__colghost');
        /* the ghost is shared — with the delayed close, another column may
           already own it by the time this fires */
        if (g0 && g0._owner === th) g0.classList.remove('is-on');
        if (th._ghostSyncs) { th._ghostSyncs.forEach(clearTimeout); th._ghostSyncs = null; }
        colCells().forEach(function (c) { c.style.transform = ''; });
        var wrap0 = table.parentElement;
        if (wrap0._padOwner === th) { wrap0.style.paddingBottom = ''; wrap0._padOwner = null; }
        if (timer) { clearInterval(timer); timer = null; }
        /* no setImg(0) here — after a column switch this column's slide refs
           point at clones already fading out inside the OTHER column's card;
           re-activating one would fade it back in. openPeek resets idx itself. */
      }
      /* delay so crossing the th/cell boundary within the column (or a cell
         sliding out from under the pointer) doesn't flicker the card closed */
      function scheduleClose() { clearTimeout(closeT); closeT = setTimeout(closePeek, 60); }
      var hoverEls = [th];
      colCells().forEach(function (c) { hoverEls.push(c); });
      hoverEls.forEach(function (el) {
        el.addEventListener('mouseenter', openPeek);
        el.addEventListener('mouseleave', scheduleClose);
      });
    });
  })();

})();
